import React from "react";

function CaretRight({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M11.3535 8.35391L6.35354 13.3539C6.30708 13.4004 6.25193 13.4372 6.19124 13.4624C6.13054 13.4875 6.06549 13.5004 5.99979 13.5004C5.93409 13.5004 5.86904 13.4875 5.80834 13.4624C5.74764 13.4372 5.69249 13.4004 5.64604 13.3539C5.59958 13.3075 5.56273 13.2523 5.53759 13.1916C5.51245 13.1309 5.49951 13.0659 5.49951 13.0002C5.49951 12.9345 5.51245 12.8694 5.53759 12.8087C5.56273 12.748 5.59958 12.6929 5.64604 12.6464L10.2929 8.00016L5.64604 3.35391C5.55222 3.26009 5.49951 3.13284 5.49951 3.00016C5.49951 2.86747 5.55222 2.74023 5.64604 2.64641C5.73986 2.55259 5.86711 2.49988 5.99979 2.49988C6.13247 2.49988 6.25972 2.55259 6.35354 2.64641L11.3535 7.64641C11.4 7.69284 11.4369 7.74799 11.4621 7.80869C11.4872 7.86938 11.5002 7.93445 11.5002 8.00016C11.5002 8.06586 11.4872 8.13093 11.4621 8.19163C11.4369 8.25233 11.4 8.30747 11.3535 8.35391Z"
        fill="#3A383F"
      />
    </svg>
  );
}

export default CaretRight;
